import { createStore } from '@stencil/store';

const initialState = {
  sessionId: '',
  visitorId: '',
  trackingId: '',
  impressions: [],
  prefix: '',
  offer: {
    offerId: '',
    offerValue: '',
    offerState: '',
    chosenCondition: '',
    status: '',
    stats: '',
    optIn: '',
  },
  replacementVehicle: {},
  cookies: [],
  pageInfo: {
    page: '',
    path: '',
    experience: '',
    partnerDescription: '',
    challengerId: '',
    productString: '',
    qs: '',
    linkName: '',
  },
  device: {
    isMobile: true,
  },
  location: {
    zip: '',
    state: '',
  },
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;

// todo: leaving this in until we get analytics implemented

// const sessionId = CookieHelper.get('SessionId') || createGuid()
// const visitorId = CookieHelper.get('VisitorId') || createGuid()
// const trackingId = getReferrerTrackingId(location, document.referrer)

// if (sessionId) CookieHelper.set('SessionId', sessionId)
// if (visitorId) CookieHelper.set('VisitorId', visitorId, 30)

// const prefix = !isAdmin ? (typeof experience !== 'undefined' && experience !== '' ? experience : 'kbb') : 'dat'

// dataLayer.impressions = []
// dataLayer.offer = {}
// dataLayer.replacementVehicle = {}

// dataLayer.cookies = setCookies(location)
// dataLayer.pageInfo = mapPage(page) || {}
// dataLayer.pageInfo.page = page
// dataLayer.pageInfo.path = `${prefix}_${isEdit ? 'edit' : 'create'}`
// dataLayer.pageInfo.experience = prefix
// dataLayer.pageInfo.partnerDescription = ''
// dataLayer.pageInfo.challengerId = ''
// dataLayer.pageInfo.productString = ''
// dataLayer.pageInfo.qs = location && location.initQueryParams ? location.initQueryParams : {}

// if (variation !== undefined) {
//   dataLayer.pageInfo.challengerId = 'us341750-' + variation
// }

// if (dataLayer.pageInfo.linkName && dataLayer.pageInfo.linkName.indexOf('vinscan') > 0) {
//   dataLayer.pageInfo.partnerDescription = `offers-${dataLayer.pageInfo.linkName.substring(dataLayer.pageInfo.linkName.indexOf('vinscan')).replace('_', '-')}`

//   // vinscan_open should be a view, not a link
//   if (dataLayer.pageInfo.linkName.indexOf('open') > 0) {
//     event = 'PageReady'
//   }
// }

// dataLayer.device.isMobile = BrowserUtils.isMobile()

// dataLayer.location.zip = globalState.zip
// dataLayer.location.state = globalState.state

// dataLayer.offer.offerCode = offerCode
// dataLayer.offer.dealerId = dealerId
// dataLayer.offer.isAssigned = isAssigned
// dataLayer.offer.isDigitalRetail = isDigitalRetail

// if (offer) {
//   if (offer.prospect) {
//     dataLayer.offer.channelId = offer.prospect.channelId
//   }

//   dataLayer.offer.offerId = offer.offerId
//   dataLayer.offer.offerValue = offer.amount

//   if (offer.chosenCondition === 'Poor') {
//     dataLayer.offer.offerState = 'offer_pc'
//   } else if (offer.status === 'INELIGIBLE') {
//     dataLayer.offer.offerState = 'offer_ne'
//   } else if (offer.stats === 'FR') {
//     dataLayer.offer.offerState = 'offer_pr'
//   } else if (!isTradeInWithinRange(offer)) {
//     dataLayer.offer.offerState = 'offer_oor'
//   } else {
//     dataLayer.offer.offerState = 'offer'
//   }
// }

// if (getQuestionResponse('qrv/LeadType').v) {
//   dataLayer.offer.optIn = getQuestionResponse('qrv/LeadType').v === 'OptIn' ? 'trade' : 'sell'

//   const lfnQ = getQuestionResponse('qrv/LookingForNewCars').v === 0
//   const lfcQ = getQuestionResponse('qrv/LookingForCertifiedCars').v === 0
//   const lfuQ = getQuestionResponse('qrv/LookingForUsedCars').v === 0

//   if (lfnQ || lfcQ || lfuQ) {
//     const yrValue = getQuestionResponseComment('qrv/YearRange') && getQuestionResponseComment('qrv/YearRange').split(',')
//     const makeName = getQuestionResponseComment('qrv/Make')
//     const modelName = getQuestionResponseComment('qrv/Model')
//     const makemodel = offer && offer.prospect && offer.prospect.replacementVehicle && offer.prospect.replacementVehicle.find(q => q.questionId === 'qrv/MakeAndModel')
//     const makemodel1 = makemodel && makemodel.subquestions.find(i => i.questionId === 'qrv/MakeModel1')
//     dataLayer.replacementVehicle.types = []

//     lfnQ && dataLayer.replacementVehicle.types.push('new')
//     lfcQ && dataLayer.replacementVehicle.types.push('cpo')
//     lfuQ && dataLayer.replacementVehicle.types.push('used')

//     dataLayer.replacementVehicle.minYear = yrValue ? (yrValue[0] <= yrValue[1] ? yrValue[0] : yrValue[1]) : ''
//     dataLayer.replacementVehicle.maxYear = yrValue ? (yrValue[1] >= yrValue[0] ? yrValue[1] : yrValue[0]) : ''
//     dataLayer.replacementVehicle.make = makeName || ''
//     dataLayer.replacementVehicle.model = modelName || ''
//     dataLayer.replacementVehicle.makeId = makemodel1 && makemodel1.value.split('/')[1]
//     dataLayer.replacementVehicle.modelId = makemodel1 && makemodel1.value.split('/')[2]
//   }
// }

// dataLayer.vehicle.vin = globalState.vin || urlState.vin || (offer && offer.prospect.vehicle.vin)
// dataLayer.vehicle.id = trim ? trim.trimId : 0
// dataLayer.vehicle.trimName = trim ? trim.displayName : ''
// dataLayer.vehicle.yearId = year ? year.yearId : 0
// dataLayer.vehicle.makeId = make ? make.makeId : 0
// dataLayer.vehicle.makeName = make ? make.displayName : ''
// dataLayer.vehicle.modelId = model ? model.modelId : 0
// dataLayer.vehicle.modelName = model ? model.displayName : ''
// dataLayer.vehicle.bodyStyle = bodyStyle || ''
// dataLayer.vehicle.transmission = transmission ? transmission.displayName : ''
// dataLayer.vehicle.drivetrain = drivetrain ? drivetrain.displayName : ''
// dataLayer.vehicle.color = color ? color.displayName : ''
// dataLayer.vehicle.trimId = offer && offer.prospect.vehicle.trimId
// dataLayer.vehicle.chosenCondition = offer && offer.chosenCondition
// dataLayer.vehicle.mileage = mileage
// dataLayer.vehicle.price = offer && offer.amount
// dataLayer.vehicle.entry = globalState.entry === 'mm' ? 'ymm' : globalState.entry || ''
